import { render, staticRenderFns } from "./WarehousePin.vue?vue&type=template&id=d6f37fba"
import script from "./WarehousePin.vue?vue&type=script&lang=js"
export * from "./WarehousePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports